import * as React from "react";
import styled from "styled-components";
import { ListGroup, ListGroupItem } from "components/bootstrap";
const StyledListGroup = styled(ListGroup)`
  margin-bottom: 0;
`;
const SliceInner = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 2px;
`;
const Title = styled.div`
  word-break: break-word;
  flex: 1;
`;
const Additional = styled.div`
  white-space: nowrap;
  display: flex;
  align-items: flex-start;
  gap: 2px;
`;
const SliceList = ({
  slices,
  activeSlice,
  sliceCol,
  onChangeSlicing,
  sliceRenderers = void 0,
  keyPrefix = "",
  listTestId = void 0
}) => /* @__PURE__ */ React.createElement(StyledListGroup, { "data-testid": listTestId }, slices.map((slice) => {
  var _a, _b, _c, _d, _e, _f, _g;
  return /* @__PURE__ */ React.createElement(
    ListGroupItem,
    {
      key: `${keyPrefix}${String(slice.value)}`,
      onClick: () => onChangeSlicing(sliceCol, String(slice.value)),
      active: String(activeSlice) === String(slice.value)
    },
    /* @__PURE__ */ React.createElement(SliceInner, null, /* @__PURE__ */ React.createElement(Title, null, (_d = (_c = (_b = (_a = sliceRenderers == null ? void 0 : sliceRenderers[sliceCol]) == null ? void 0 : _a.render) == null ? void 0 : _b.call(_a, slice)) != null ? _c : slice.title) != null ? _d : String(slice.value)), ((_e = sliceRenderers == null ? void 0 : sliceRenderers[sliceCol]) == null ? void 0 : _e.renderAdditional) ? /* @__PURE__ */ React.createElement(Additional, null, (_g = (_f = sliceRenderers == null ? void 0 : sliceRenderers[sliceCol]) == null ? void 0 : _f.renderAdditional) == null ? void 0 : _g.call(_f, slice)) : null)
  );
}));
export default SliceList;
